"use strict";

exports.__esModule = true;
exports.getXTickFormatter = exports.getTimeSeriesXTickFormatter = exports.getHourXTickFormatter = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _timeAggregationBinMapping = require("../../../VIMANAMetrics/timeAggregationBinMapping");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getQuarterTick = function getQuarterTick(timestamp) {
  var quarterMonth = _moment["default"].utc(timestamp).format("MMM");
  if (quarterMonth === "Jan") {
    return "Q1-Jan'" + _moment["default"].utc(timestamp).format("YY");
  } else if (quarterMonth === "Apr") {
    return "Q2-Apr'" + _moment["default"].utc(timestamp).format("YY");
  } else if (quarterMonth === "Jul") {
    return "Q3-Jul'" + _moment["default"].utc(timestamp).format("YY");
  } else if (quarterMonth === "Oct") {
    return "Q4-Oct'" + _moment["default"].utc(timestamp).format("YY");
  } else {
    return quarterMonth;
  }
};
var getXTickValue = function getXTickValue(timestamp, aggregateTimeBy) {
  if (aggregateTimeBy) {
    if (aggregateTimeBy === _timeAggregationBinMapping.HOUR_PER_DAY) {
      if (_moment["default"].utc(timestamp).get("hour") === 0) {
        return _moment["default"].utc(timestamp).format("DD MMM");
      }
      return _moment["default"].utc(timestamp).format("HH:00");
    } else if (aggregateTimeBy === _timeAggregationBinMapping.HOUR_OF_DAY) {
      return timestamp + ":00";
    } else if (aggregateTimeBy === "month") {
      return _moment["default"].utc(timestamp).format("MMM'YY");
    } else if (aggregateTimeBy === "quarter") {
      return getQuarterTick(timestamp);
    } else if (aggregateTimeBy === "year") {
      return _moment["default"].utc(timestamp).format("YYYY");
    }
  }
  return _moment["default"].utc(timestamp).format("DD MMM");
};
var getTimeSeriesXTickFormatter = exports.getTimeSeriesXTickFormatter = function getTimeSeriesXTickFormatter(_ref) {
  var scale = _ref.scale,
    width = _ref.width,
    timezone = _ref.timezone;
  var tickCount = Math.max(2, Math.floor(width / 60));
  var tickFormat = scale.tickFormat(tickCount);
  return function (timestamp) {
    var ts = new Date(timestamp);
    return tickFormat(new Date(Number(ts) + timezone.currentOffsetMillis));
  };
};
var getXTickFormatter = exports.getXTickFormatter = function getXTickFormatter(_ref2) {
  var windowType = _ref2.windowType,
    scale = _ref2.scale,
    width = _ref2.width,
    timezone = _ref2.timezone;
  if (windowType === "timeseries" && scale && width && timezone) {
    return getTimeSeriesXTickFormatter({
      scale: scale,
      width: width,
      timezone: timezone
    });
  }
  return function (timestamp) {
    return getXTickValue(timestamp, windowType);
  };
};
var getHourXTickFormatter = exports.getHourXTickFormatter = function getHourXTickFormatter() {
  return function (timestamp) {
    return _moment["default"].utc(timestamp).format("YYYY-MM-DD HH:mm");
  };
};